export enum BonusProgramType {
  FIXED_ANY = "fixed_any",
  FIXED_SINGLE = "fixed_single",
}
